/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const UploadIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M4 16h12v-3h2v5H2v-5h2z" />
    <path d="M14 9h-3v5H9V9H6l4-6z" />
  </g>,
);
